import React from 'react';
import { Star } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { testimonials } from '../../mock';

export const Testimonials = () => (
      <section id="testimonials" className="py-20 bg-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">What Our <span className="text-yellow-500">Clients Say</span></h2>
            <div className="w-24 h-1 bg-yellow-400 mx-auto mb-4"></div>
            <p className="text-lg text-gray-600">Don't just take our word for it - hear from our satisfied customers.</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {testimonials.map((testimonial) => (
              <Card key={testimonial.id} className="border border-gray-200 hover:border-yellow-400 hover:shadow-xl transition-all bg-gray-50">
                <CardHeader>
                  <div className="flex items-center space-x-1 mb-4">
                    {Array.from({ length: testimonial.rating }, (_, i) => `${testimonial.id}-star-${i + 1}`).map((starId) => (
                      <Star key={starId} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                    ))}
                  </div>
                  <CardTitle className="text-lg text-gray-900">{testimonial.name}</CardTitle>
                  <CardDescription className="text-gray-500">{testimonial.location}</CardDescription>
                </CardHeader>
                <CardContent>
                  <p className="text-gray-600 mb-4">"{testimonial.text}"</p>
                  <span className="inline-block bg-yellow-100 border border-yellow-300 text-yellow-700 text-xs font-medium px-3 py-1 rounded-full">
                    {testimonial.service}
                  </span>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>
);
